import styled from 'styled-components';

export const StyledModalForm = styled.div`
  .form-details{
    .form-input-fields {
      min-width: 125px;
      padding: 0px;
      padding-bottom: 10px;
      .css-2b097c-container{
        font-family: Lato,sans-serif;
      }

      .irGLIb {
        height:25px;
        width: 206px;
      }

      .MuiGrid-container {
        min-width: 230px;
        padding: 0px;
        height: 38px;
        .MuiFormControl-marginNormal {
          margin-top: 0px;
        }
      }
    }
    .handler-picker {
       .MuiGrid-container {
        width: 230px;
        padding: 0px;
      }
    }
  }

  .form-details-with-time-picker{
  width: 40%;
  border-collapse: collapse;
    margin-left: 25px;
    margin-top: 10px;

    .form-input-fields {
      min-width: 125px;
      padding: 0px;
      padding-bottom: 10px;

      .MuiGrid-container {
        min-width: 150px;
        padding: 0px;
      }
    }
    .left-section {
      padding-left: 50px;
    }
  }
  .generated-list {
    padding: 10px 24px !important;
  }
  .fkTuFL{
    max-height: 500px;
  }
.MuiFormGroup-root {
  flex-direction: row;
}
.MuiRadio-colorSecondary.Mui-checked {
  color: rgb(0, 153, 206) !important
}

.disabled-input .bnjtTM {
    color: #575858!important;
    background-color: white!important;

}
.disabled-input-handler .bnjtTM {
    width: 475px;
    color: #575858!important;
    background-color: white!important;
}

.validation-message {
      width: 360px;
      margin: 25px 10px 10px 30px;
     span {
      color: red;
      }
    }
.flight-validation-message {
      width: 360px;
      margin: 25px 10px 10px 50%;
     span {
      color: red;
      }
}
.info-message {
      width: 360px;
      margin: 25px 10px 10px 30px;
     span {
      font-style: italic;
      }
    }
`;
